import { get } from "lodash";

const UNSAFE_ERROR =
  /Authorization|Bearer |apikey_|Unexpected error value|set-cookie/i;

export const toSafeRemoteErrorMessage = (error, fallback) => {
  const message =
    get(error, "graphQLErrors.0.message") || get(error, "message") || "";
  if (!message || UNSAFE_ERROR.test(message)) {
    return fallback;
  }
  return message;
};
